import React from 'react';
import { array, bool, string } from 'prop-types';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import Variations from '../Variations';
import { useChooseVariationContext } from '../Context';
import classes from './style.module.scss';

const VariationsRow = ({ variations, isProjectOwner, copiesKey, withoutTitle = false }) =>
    !!variations.length && (
        <div className={classes.variationsCardItem}>
            {!withoutTitle && (
                <h6>
                    <I18n k={`logo_maker_perseus.choose_variation.thumbnails.${copiesKey}.title`} />
                </h6>
            )}
            <Variations
                className={classes.variationContainer}
                variations={variations}
                isProjectOwner={isProjectOwner}
            />
        </div>
    );

VariationsRow.propTypes = {
    variations: array,
    isProjectOwner: bool,
    copiesKey: string,
    withoutTitle: bool,
};

const VariationsCard = ({ className, isProjectOwner = false }) => {
    const { draftVariations, orderedVariations, suggestedVariations } = useChooseVariationContext();

    return (
        <div className={classnames(classes.variationsCard, className)}>
            <div className={classes.variationsScrollBox}>
                <VariationsRow variations={draftVariations} isProjectOwner={isProjectOwner} copiesKey="your_designs" />
                <VariationsRow variations={orderedVariations} isProjectOwner={isProjectOwner} copiesKey="your_orders" />
                <VariationsRow
                    variations={suggestedVariations}
                    isProjectOwner={isProjectOwner}
                    copiesKey="designer_recommended"
                    withoutTitle={!draftVariations.length && !orderedVariations.length}
                />
            </div>
        </div>
    );
};

VariationsCard.propTypes = {
    className: string,
    isProjectOwner: bool,
};

export default VariationsCard;
